import { Sluggable } from '@client/core/data/concerns/sluggable';
import { $t } from '@client/i18n/t';

/**
 * @see config/projects.php
 */
export enum PropertyTypeSlug {
  SingleFamilyHome = 'single_family_home',
  Condo = 'condo',
  Townhouse = 'townhouse',
  Apartment = 'apartment',
  Duplex = 'duplex',
  Triplex = 'triplex',
  Quadplex = 'quadplex',
  ApartmentBuilding = 'apartment_building',
  CommercialBuilding = 'commercial_building',
  MobileHomeManufactured = 'mobile_home_manufactured',
  VacantLand = 'vacant_land',
  Other = 'other',
}

export class PropertyType extends Sluggable<PropertyType>({ returnAsIsWhenSlugMissing: true }) {
  static readonly singleFamilyHome = new PropertyType({
    name: $t('project.propertyTypes.singleFamilyHome'),
    slug: PropertyTypeSlug.SingleFamilyHome,
  });

  static readonly condo = new PropertyType({
    name: $t('project.propertyTypes.condo'),
    slug: PropertyTypeSlug.Condo,
  });

  static readonly townhouse = new PropertyType({
    name: $t('project.propertyTypes.townhouse'),
    slug: PropertyTypeSlug.Townhouse,
  });

  static readonly apartment = new PropertyType({
    name: $t('project.propertyTypes.apartment'),
    slug: PropertyTypeSlug.Apartment,
  });

  static readonly duplex = new PropertyType({
    name: $t('project.propertyTypes.duplex'),
    slug: PropertyTypeSlug.Duplex,
  });

  static readonly triplex = new PropertyType({
    name: $t('project.propertyTypes.triplex'),
    slug: PropertyTypeSlug.Triplex,
  });

  static readonly quadplex = new PropertyType({
    name: $t('project.propertyTypes.quadplex'),
    slug: PropertyTypeSlug.Quadplex,
  });

  static readonly apartmentBuilding = new PropertyType({
    name: $t('project.propertyTypes.apartmentBuilding'),
    slug: PropertyTypeSlug.ApartmentBuilding,
  });

  static readonly commercialBuilding = new PropertyType({
    name: $t('project.propertyTypes.commercialBuilding'),
    slug: PropertyTypeSlug.CommercialBuilding,
  });

  static readonly mobileHomeManufactured = new PropertyType({
    name: $t('project.propertyTypes.mobileHomeManufactured'),
    slug: PropertyTypeSlug.MobileHomeManufactured,
  });

  static readonly vacantLand = new PropertyType({
    name: $t('project.propertyTypes.vacantLand'),
    slug: PropertyTypeSlug.VacantLand,
  });

  static readonly other = new PropertyType({
    name: $t('project.propertyTypes.other'),
    slug: PropertyTypeSlug.Other,
  });

  static readonly values: PropertyType[] = [
    this.apartment,
    this.apartmentBuilding,
    this.commercialBuilding,
    this.condo,
    this.duplex,
    this.mobileHomeManufactured,
    this.other,
    this.quadplex,
    this.singleFamilyHome,
    this.townhouse,
    this.triplex,
    this.vacantLand,
  ];
}
